import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;

  border-bottom: 1px solid var(--border-neutral-faded, #dfe2ea);
  box-sizing: border-box;

  position: relative;
`

export const NavItemContainer = styled.div`
  min-width: 45px;
  height: 42px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;

  cursor: pointer;
`

export const NavItemLabel = styled.div`
  color: var(--foreground-neutral, #14171f);

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`

export const BarIndicator = styled.div`
  position: absolute;
  bottom: -1px;

  height: 2px;

  border-radius: 4px;
  background: var(--border-primary, #4d4be7);

  transition: left 0.3s, width 0.3s;
`
